<template>
    <div>
        <LocationSelector :locations="locations" :value="value.locations" @input="updateLocations" />
        <PeriodSelector :value="value.period" @input="updatePeriod" />
        <div class="wrapper">
            <SelectBox
                id="forAT_AddWidget-nurseCalls"
                :placeholder="$t('reporting.commonLabels.callType')"
                :value="value.nurse_call"
                :options="nurseCalls"
                @input="updateNurseCall"
            />
        </div>
    </div>
</template>

<script>
import SelectBox from './../../common/SelectBox.vue';
import LocationSelector from './common/LocationSelector.vue';
import PeriodSelector from './common/PeriodSelector.vue';
import { translateOptions, nurseCalls as nurseCallsArray, createUpdaters } from '../widgetHelpers';

export default {
    components: {
        LocationSelector,
        PeriodSelector,
        SelectBox,
    },

    props: {
        locations: {
            type: Array,
            required: true,
        },

        value: {
            type: Object,
            required: true,
        },
    },

    computed: {
        /**
         * Returns a list of options for periods dropdown
         * {{ name: string, value: number}[]}
         */
        nurseCalls() {
            return translateOptions(this.$t.bind(this), nurseCallsArray);
        },
    },

    methods: createUpdaters('period', 'nurse_call', 'locations'),
};
</script>
